import { Link } from 'react-router-dom'
import { siteContent } from '../data/content'
import { trackCtaClick } from '../utils/analytics'

export default function Hero() {
  const hero = siteContent.products.wms.hero

  return (
    <section className="relative bg-gradient-to-b from-amber-50 to-white overflow-hidden">
      <div className="container-custom py-16 md:py-24 lg:py-32">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Content */}
          <div className="text-center lg:text-left">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-navy-900 leading-tight">
              {hero.headline}
            </h1>
            <p className="mt-6 text-lg md:text-xl text-navy-600 max-w-2xl mx-auto lg:mx-0">
              {hero.subheadline}
            </p>
            {/* ICP Statement */}
            <p className="mt-4 text-sm font-medium text-amber-600">
              Built for Philippine warehouses, distribution centers, and 3PLs
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Link to="/contact" className="inline-flex items-center justify-center px-6 py-3 rounded-lg font-semibold transition-colors bg-amber-600 text-white hover:bg-amber-700" onClick={() => trackCtaClick('hero_demo')}>
                {hero.primaryCta}
              </Link>
              <Link to="/pricing/wms" className="btn-secondary text-center" aria-label="View WMS pricing" onClick={() => trackCtaClick('hero_pricing')}>
                See Pricing
              </Link>
            </div>
          </div>

          {/* Product Visual Placeholder */}
          <div className="relative">
            <div className="bg-white rounded-xl shadow-2xl border border-navy-200 overflow-hidden">
              <div className="bg-navy-800 px-4 py-3 flex items-center space-x-2">
                <div className="w-3 h-3 rounded-full bg-red-500"></div>
                <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
                <div className="w-3 h-3 rounded-full bg-green-500"></div>
                <span className="ml-4 text-sm text-navy-300">Warehouse Operations</span>
              </div>
              <div className="p-6 bg-navy-50">
                {/* Mock Dashboard UI */}
                <div className="grid grid-cols-3 gap-4 mb-6">
                  <div className="bg-white p-4 rounded-lg shadow-sm">
                    <div className="text-xs text-navy-500 uppercase tracking-wide">Active SKUs</div>
                    <div className="text-2xl font-bold text-navy-900 mt-1">4,812</div>
                    <div className="text-sm text-amber-600 mt-1">248 locations</div>
                  </div>
                  <div className="bg-white p-4 rounded-lg shadow-sm">
                    <div className="text-xs text-navy-500 uppercase tracking-wide">Open POs</div>
                    <div className="text-2xl font-bold text-amber-600 mt-1">27</div>
                    <div className="text-sm text-navy-500 mt-1">8 receiving</div>
                  </div>
                  <div className="bg-white p-4 rounded-lg shadow-sm">
                    <div className="text-xs text-navy-500 uppercase tracking-wide">Expiring</div>
                    <div className="text-2xl font-bold text-red-600 mt-1">12</div>
                    <div className="text-sm text-navy-500 mt-1">within 30 days</div>
                  </div>
                </div>
                <div className="bg-white rounded-lg shadow-sm p-4">
                  <div className="flex items-center justify-between border-b border-navy-100 pb-3 mb-3">
                    <span className="font-medium text-navy-900">Inventory by Location</span>
                    <span className="text-sm text-navy-500">Sorted by FIFO</span>
                  </div>
                  <div className="space-y-2">
                    <div className="flex items-center justify-between py-2 border-b border-navy-50">
                      <span className="text-navy-700">A-01-02 · SKU-12345 · LOT-2026-001</span>
                      <span className="text-sm font-medium text-amber-600">150 units</span>
                    </div>
                    <div className="flex items-center justify-between py-2 border-b border-navy-50">
                      <span className="text-navy-700">B-03-01 · SKU-49820 · LOT-2026-004</span>
                      <span className="text-sm font-medium text-navy-600">84 units</span>
                    </div>
                    <div className="flex items-center justify-between py-2">
                      <span className="text-navy-700">C-02-05 · SKU-30117 · LOT-2026-007</span>
                      <span className="text-sm font-medium text-navy-600">212 units</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
